import IngredientDetail, { IngredientDetailProps } from "./IngredientDetail";

export { IngredientDetail, IngredientDetailProps };

export default IngredientDetail;
